<template>
    <div class="custom-cascader el-cascader" :style="{ minWidth: filterable ? '300px' : '250px' }">
        <el-popover
            v-model:visible="panelDisplay"
            placement="bottom"
            trigger="click"
            width="fit-content"
            popperClass="p-0 custom-cascader-popover__popper"
            @hide="search = ''"
            @show="setFocus"
        >
            <el-cascader-panel
                v-if="!filtering"
                v-model="selectedValues"
                :options="options"
                :props="props"
                @change="update"
            >
                <template #default="{ node, data }">
                    <div @click="cascaderClick(node, data)">{{ data.label }}</div>
                </template>
            </el-cascader-panel>
            <div v-else class="cascader-suggestion">
                <ul class="py-2 m-0">
                    <li
                        v-for="suggestion in suggestions"
                        :key="suggestion.value"
                        @click="updateSuggestion(suggestion.value)"
                    >
                        <div
                            class="suggestion-item cpointer prelative wp-10"
                            :class="[isChecked(suggestion.value) ? 'blue semibold' : '']"
                        >
                            <span class="suggestion-item-label">{{ suggestion.label }}</span>
                            <i
                                v-if="isChecked(suggestion.value)"
                                class="fright el-icon-check primary-50 semibold"
                            />
                        </div>
                    </li>
                </ul>
            </div>
            <template #reference>
                <div class="cascader-input el-input el-input--suffix">
                    <el-input readonly>
                        <template #suffix>
                            <CompassIcon
                                type="primary"
                                :icon="panelDisplay ? 'caret-up' : 'caret-down'"
                            />
                        </template>
                    </el-input>
                    <div class="cascader-items">
                        <div v-if="previewItems.length > 0" class="item p-1">
                            <span class="item-txt pl-2">{{ previewItems[0].label }}</span>
                        </div>
                        <div v-if="previewItems.length > 1" class="item p-1">
                            <span class="item-tag">+{{ previewItems.length - 1 }}</span>
                        </div>
                        <div v-if="filterable" class="item-search ml-1">
                            <input
                                ref="search"
                                v-model="search"
                                type="text"
                                class="b-0"
                                @input="filterOptions"
                                @focus="forceOpenPanel"
                            />
                        </div>
                        <div
                            v-if="placeholder != '' && previewItems.length == 0"
                            class="cascader-placeholder"
                        >
                            <span>{{ placeholder }}</span>
                        </div>
                    </div>
                </div>
            </template>
        </el-popover>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: [Array, Number],
            required: true,
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        filterable: {
            type: Boolean,
            required: false,
            default: false,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        multiple: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            search: '',
            panelDisplay: false,
            suggestions: [],
            props: {
                multiple: this.multiple,
                expandTrigger: 'hover',
                emitPath: false,
            },
            selectedValues: this.modelValue,
        };
    },
    computed: {
        filtering() {
            return this.search != '';
        },
        previewItems() {
            const previewItems = [];
            this.options.map((group) => {
                group.children.map((child) => {
                    if (this.multiple) {
                        if (this.isChecked(child.value)) {
                            previewItems.push(child);
                        }
                    } else {
                        if (this.modelValue == child.value) {
                            previewItems.push(child);
                        }
                    }
                });
            });
            return previewItems;
        },
    },
    watch: {
        value(newVal) {
            this.selectedValues = newVal;
        },
    },
    methods: {
        isChecked(value) {
            return this.multiple
                ? this.selectedValues.flat().includes(value)
                : this.selectedValues === parseInt(value);
        },
        filterOptions() {
            this.suggestions = [];
            if (this.filtering) {
                this.options.map((group) => {
                    const childs = group.children.filter(
                        (child) =>
                            child.label
                                .toLowerCase()
                                .normalize('NFD')
                                .replace(/[\u0300-\u036f]/g, '')
                                .indexOf(
                                    this.search
                                        .toLowerCase()
                                        .normalize('NFD')
                                        .replace(/[\u0300-\u036f]/g, ''),
                                ) > -1,
                    );
                    childs.map((child) => {
                        this.suggestions.push(child);
                    });
                });
            } else {
                this.suggestions = this.options;
            }
            this.$forceUpdate();
        },
        forceOpenPanel() {
            setTimeout(() => {
                this.panelDisplay = true;
            }, 100);
        },
        updateSuggestion(value) {
            if (!this.multiple) {
                this.update([]);
            }
            if (!this.isChecked(value)) {
                this.multiple
                    ? this.update([...this.selectedValues, ...[value]])
                    : this.update(value);
            } else {
                this.multiple
                    ? this.update(this.selectedValues.filter((val) => val != value))
                    : this.update([]);
            }
        },
        update(value) {
            this.$emit('update:modelValue', value);
        },
        cascaderClick(node, data) {
            const val = [];
            if (this.multiple) {
                if (this.selectedValues.flat().includes(node.value)) {
                    let valueTmp = [...this.selectedValues];
                    if (!_.isNil(data.children)) {
                        valueTmp = [];
                    } else {
                        valueTmp.splice(
                            valueTmp.findIndex((item) => item == node.value),
                            1,
                        );
                    }

                    this.selectedValues = valueTmp;
                    this.update(this.selectedValues);
                } else if (node.hasChildren && node.checked) {
                    data.children.forEach((child) => {
                        this.selectedValues = this.selectedValues.filter(
                            (value) => value !== child.value,
                        );
                    });
                    this.update(this.selectedValues);
                } else {
                    if (!_.isNil(data.children)) {
                        data.children.forEach((subChoice) => val.push(subChoice.value));
                    } else {
                        val.push(node.value);
                    }

                    this.selectedValues = [...this.selectedValues, ...val];
                    this.update(this.selectedValues);
                }
            } else {
                this.selectedValues = node.path;
                this.update(node.value);
            }
        },
        setFocus() {
            this.$refs.search ? this.$refs.search.focus() : false;
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;
.custom-cascader.el-cascader {
    .cascader-items {
        position: absolute;
        left: 0;
        right: 30px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        line-height: normal;
        text-align: left;
        box-sizing: border-box;
        .item {
            display: inline-flex;
            align-items: center;
            .item-img {
                width: 20px;
                height: 20px;
                border-right: var(--spacing-0);
            }
            .item-txt {
                display: inline-block;
                max-width: 150px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
            .item-tag {
                background-color: $lightgrey;
                font-weight: $font-weight-semibold;
                border-right: var(--spacing-0);
                padding: 0 4px;
            }
        }
        .item-search {
            align-items: center;
            display: flex;
            width: 50px;
        }
        .cascader-placeholder {
            padding-left: 12px;
            color: $gray-100;
        }
    }
    .el-input__icon.el-icon-arrow-up {
        color: $gray-100;
        transform: rotate(180deg);
        &.is-reverse {
            transform: rotate(0deg);
        }
    }
    .el-input__suffix {
        right: 6px;
    }
}
.cascader-suggestion {
    min-width: 250px;
    ul {
        li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 34px;
            padding: 0 16px;
            text-align: left;
            outline: none;
            cursor: pointer;
            &:hover {
                background-color: $gray-0;
            }
            .suggestion-item {
                .suggestion-item-label {
                    max-width: 350px;
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    padding-right: 4px;
                }
                i {
                    line-height: 1.4;
                }
            }
        }
    }
}
// Cascader popper element
.custom-cascader-popover__popper {
    .el-cascader-node {
        padding-left: 12px;
        padding-right: var(--spacing-5);
        height: 32px;
        line-height: 32px;
    }
    .el-cascader-menu {
        color: $gray-100;
    }
    .el-cascader-menu:last-child .el-cascader-node {
        padding-right: 12px;
    }
    .el-cascader-node.in-active-path,
    .el-cascader-node.is-active,
    .el-cascader-node.is-selectable.in-checked-path {
        color: $primary-50;
        font-weight: $font-weight-regular;
    }
    .el-cascader-node:not(.is-disabled):focus,
    .el-cascader-node:not(.is-disabled):hover {
        background: $primary-05;
        font-weight: $font-weight-regular;
    }
    .el-cascader-node__label {
        padding: 0 var(--spacing-1);
    }
    .el-cascader-node__postfix {
        right: 12px;
        color: $gray-60;
    }
}
</style>
